import * as React from "react";
import { renderRoutes } from "react-router-config";

import Header from "./Header";

import { PROOFREADER } from '../../Shared/utils/constants';
import { routes } from "../routes";
import { ReadAloudProvider, ScreenreaderInstructions, getParameterByName, } from '../../Shared/index';

export default class PageLayout extends React.Component<any, { showFocusState: boolean, hasPassageButtons: boolean }> {
  constructor(props: any) {
    super(props)

    this.state = {
      showFocusState: false,
      hasPassageButtons: false
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
  }

  setHasPassageButtons = () => {
    const { hasPassageButtons} = this.state
    this.setState({ hasPassageButtons: !hasPassageButtons });
  };

  handleKeyDown = (e: any) => {
    if (e.key !== 'Tab') { return }

    const { showFocusState, } = this.state

    if (showFocusState) { return }

    this.setState({ showFocusState: true })
  }

  handleSkipToMainContentClick = () => {
    const element = document.getElementById("main-content")
    if (!element) { return }
    element.focus()
    element.scrollIntoView()
  }

  handleSkipToPassageButtonsClick = () => {
    const element = document.getElementById("button-container")
    if (!element) { return }
    element.focus()
    element.scrollIntoView(false)
  }

  render() {
    const { showFocusState, hasPassageButtons } = this.state
    let className = "ant-layout activity-container "
    className += showFocusState ? '' : 'hide-focus-outline'
    const header = window.location.href.includes('play') ? <Header /> : null
    const routeProps = { setHasPassageButtons: this.setHasPassageButtons };
    return (
      <ReadAloudProvider activitySessionUid={getParameterByName('student', window.location.href)} tool={PROOFREADER}>
        <div className={className}>
          <div className="page-content">
            <ScreenreaderInstructions />
            <button className="skip-main" onClick={this.handleSkipToMainContentClick} type="button">Skip to main content</button>
            {hasPassageButtons && <button className="skip-main" onClick={this.handleSkipToPassageButtonsClick} type="button">Skip to passage buttons</button>}
            {header}
            <main id="main-content" tabIndex={-1}>{renderRoutes(routes, routeProps)}</main>
          </div>
        </div>
      </ReadAloudProvider>
    );
  }
};
